
export class ConnectionTransport {
private _name: string;
/**
 * @return {?}
 */
get name(): string {
        return this._name;
    }
/**
 * @param {?} name
 */
constructor(name: string) {
        if (name == null || name === "") {
            throw new Error("Failed to create ConnectionTransport. Argument 'name' can not be null or empty.");
        }
        this._name = name;
    }
/**
 * @return {?}
 */
public toString(): string {
        return this._name;
    }
/**
 * @param {?} other
 * @return {?}
 */
public equals(other: ConnectionTransport): boolean {
        if (other == null) {
            return false;
        }

        return this._name === other.name;
    }
}

function ConnectionTransport_tsickle_Closure_declarations() {
/** @type {?} */
ConnectionTransport.prototype._name;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
